// External imports
import React from "react";
import {
    AboutCardContainer,
    AboutDetails,
    AboutHeading,
    ButtonContainer,
} from "./AboutCard.styles";
import WebsiteButton from "../../../../../components/core/button/WebsiteButton";
import { HiOutlineArrowDown } from "react-icons/hi";
import { SupportedLanguage } from "../../../../../core/translations/supportedLanguages";
import { AboutButtons } from "./translations/types";
import { enTranslations } from "./translations/en";
import { deTranslations } from "./translations/de";
import { useLanguage } from "../../../../../core/translations/LanguageContext";

// Internal imports

/**
 * Props for the AboutCard component
 * @property title - Title of the about
 * @property detail - Description or details of about
 */
interface AboutCardProps {
    title: string;
    detail: string;
    handleReadMore: () => void;
}

/**
 * AboutCard component
 * Displays a about card with title, detail
 *
 */
const TRANSLATIONS: Record<SupportedLanguage, AboutButtons> = {
    en: enTranslations,
    de: deTranslations,
};


const AboutCard: React.FC<AboutCardProps> = ({ title, detail, handleReadMore  }) => {
        const { language } = useLanguage();
        const translations = TRANSLATIONS[language];
    return (
        <AboutCardContainer>
            <AboutHeading>{title}</AboutHeading>
            <AboutDetails>{detail}</AboutDetails>
                </AboutCardContainer>
    );
};

export default AboutCard;
